module.exports = __webpack_public_path__ + "static/media/darkpit_0.3b7a9fa3.png";